import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { LabelStyleDialogComponent } from './label-style-dialog.component';
import { DictHandler, SimpleHandler, AnyHandler } from 'src/app/types/@types/sl-v-types';
import { LabelStyle } from 'src/app/types/LabelStyle';



@Injectable({
	providedIn: 'root'
})
export class LabelStyleDialogService {
	public request$: Subject<any> = new Subject();
	constructor() { }


	Show(handler: AnyHandler, style: LabelStyle = '', viewOnly: boolean = false) {
		if (style === '') {
			this.request$.next({ handler: (handler), viewOnly: (viewOnly) });
		} else {
			this.request$.next({ handler: (handler), style: (style), viewOnly: (viewOnly) });
		}
	}


}

